import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SkipLink from './SkipLink';
import Header from './Header';
import Footer from './Footer';
import Container from '../ui/Container';
import AssistantProvider from '../assistant/AssistantProvider';
import AssistantWidget from '../assistant/AssistantWidget';

/**
 * Shown while a lazily-loaded route chunk is being fetched.
 */
export const RouteLoading = () => (
  <Container>
    <div className="route-loading" role="status" aria-live="polite">
      <span className="route-loading__spinner" aria-hidden="true" />
      <span>Loading page content&hellip;</span>
    </div>
  </Container>
);

/**
 * Public marketing shell: header, routed content, footer, assistant widget.
 *
 * The routed content is wrapped in Suspense so each page can be code-split
 * without the header or footer unmounting during navigation.
 *
 * AssistantProvider wraps everything because two places need the widget's open
 * state: the widget lives here permanently, and the invitation section inside
 * the routed content renders a button that opens it. Props cannot cross the
 * Outlet boundary, so context is the smallest thing that works.
 */
const MarketingLayout = () => (
  <AssistantProvider>
    <div className="app-shell">
      <SkipLink />
      <Header />

      <main className="app-main" id="main-content" tabIndex={-1}>
        <Suspense fallback={<RouteLoading />}>
          <Outlet />
        </Suspense>
      </main>

      <Footer />

      <AssistantWidget />
    </div>
  </AssistantProvider>
);

export default MarketingLayout;
